import React, { useEffect, useState } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state"
import { queryTools } from "lib/utils"
import { useCompositeQuery } from "lib/hooks"
import { DisputePreview } from "lib/units/dispute"

/* ===  
  Use case 1:
  The client does not need to make any changes. The PDF just needs to be generated.
  The MM server makes a direct call to express at:  /api/getpdf/:tmplid?rp=257&subdomain=woopla 
  Playwright then makes a call to the React app (/pdf?tmplid?rp=subdomain) and converts the html + css to a PDF, and sends it back.

  Use case 2:
  The client wants to make changes and we want to use the same wysiwyg tools as always.
  The MM server makes a call to express and Playwright grabs the html + css from the React app sends it back as a single file.

  Use case 3:
  The client wants to make changes but we want to use the new editing tools.
  The MM server launches a pre-built web component which communicates with this app via api calls. The remote app allows the 
  client to make changes and then generates the PDF as above.

  =============

  This component is ultimately client-facing. It would appear on the MM server as a web component when a client wants to edit their dispute.
  the express server receives a request from the MM server for a template along with rp and subdomain.
  the express server looks up the Mongo id of the template and sends that to React along with the rp and subdomain.

  this file receives that request, and looks up the complete template info.
  the TemplateRenderWrapper component MUST receive the entire template object, not just the id.

  when generating a pdf, we may need to specify height and width. But in all other instances, that does not apply.
  === */


export default function GeneratePDF() {

  const { dspid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams();

  const { store, AppStore }:any = appStore()
  const { update } = AppStore

  // const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { _id: dspid }, { enabled: !!dspid })

  // const [ dispute, setDispute ] = useState<any>(null)
  const [ renderPkg, setRenderPkg ] = useState<any>(null)

  // const { data:_DisputeData }= useCompositeQuery({
  //   dispute: dspid || "",
  //   subdomain: searchParams.get("subdomain") || "",
  //   rp: searchParams.get("rp") || "",
  //   callback: (data:any) => {
  //     console.log("pdf data", data)
  //     if( data.result !== "success" ) throw new Error(data.msg)
  //     setRenderPkg((prev:any) => ({ ...prev, ...data.payload, mode: "pdf", origin: searchParams.get("origin") || "midmetrics" }))
  //   }
  // })

  const getRenderWidth = () => {
    const paramsWidth = searchParams.get("width")
    const pdfWidth = (searchParams.get("mode") === "pdf") ? 1100 : undefined
    const fallbackWidth = 980
    return paramsWidth || pdfWidth || fallbackWidth
  }

  const getRenderHeight = () => {
    const paramsHeight = `${searchParams.get("height")}px` || undefined
    const pdfHeight = (searchParams.get("mode") === "pdf") ? '2000px' : undefined
    const fallbackHeight = '2000px'
    return paramsHeight || pdfHeight || fallbackHeight
  }

  const getRenderScale = ():string|number => {
    let paramsScale:any = searchParams.get("scale") || undefined
    if( paramsScale ){
      paramsScale = parseFloat(paramsScale)
    }
    const pdfScale = (searchParams.get("mode") === "pdf") ? 1 : undefined
    const fallbackScale = 1
    return paramsScale || pdfScale || fallbackScale
  }


  useEffect(() => {
    update("viewmode", "pdf")
  },[])

  // useEffect(() => {
  //   if( _Dispute ){
  //     setDispute(_Dispute)
  //   }
  // },[_Dispute])

  // if( !renderPkg ) return <></>
  return (
    <div id="mm-pdf-render">
      <div style={{
        width: "100%",
        margin: "0 auto",
        padding: ".5rem 12rem",
      }}>
        <DisputePreview
          mode="pdf"
          subdomain={searchParams.get("subdomain") || ""}
          origin={searchParams.get("origin") || "midmetrics"}
          rp={searchParams.get("rp") || ""}
          // pdfRenderPkg={renderPkg}
          config={{
            width: getRenderWidth(),
            maxWidth: getRenderWidth(),
            height: getRenderHeight(),
            scale: getRenderScale()
          }}
        />
      </div>
    </div>
  )
}


